import styles from "./style.module.css";
import StartFooter from "../../../components/Common/StartFooter";
import group from "./Vector.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import UmooveApi from "../../../components/api/UmooveApi";
import mainContext from "../../../context/mainContext";
import dataContext from "../../../context/dataContext";
import userRequests from "../../../components/api/userRequests";

// Creator : Team A -efrat & Yehoantan
function CameraFace() {
   const navigate = useNavigate();
   const location = useLocation()
   const videoRef = useRef();
   // const [count, setCount] = useState(0);
   const [loader, setLoader] = useState("loadImg");

   const {
      header: { setPageName, setIsShowHeader },
      stream: { setStreamObj, streamObj },
      initCam: { alreadiInit, setAlreadyInit }
   } = useContext(mainContext)
   const { examData, userDetails } = useContext(dataContext)

   useEffect(() => {
      let waitForCameraPluginInterval;
      if (window.buildType == "iPhone") {
         setIsShowHeader(false)
      } else {

         setPageName("Prepare Camera")
      }
      console.log("🚀 ~ useEffect ~ alreadiInit:", alreadiInit)
      window.debuggCollector("PrepareCameraPage", { alreadiInit })
      if (!alreadiInit) {//prevent init when go back history

         if (window.cordovaOn) {
            waitForCameraPluginInterval = setInterval(() => {
               console.log(" waitForCameraPluginInterval:", waitForCameraPluginInterval);
               if (window.cameraOnFlag) {
                  setLoader("");//mean that the camera now is on- client can press next now
                  clearInterval(waitForCameraPluginInterval);
               }
            }, 500);
            window.debuggCollector("goingToInitFromCameraPage", { alreadiInit })
            UmooveApi.API_loadUmooveLibrary()
            window.debuggCollector("finishToInitFromCameraPage", { alreadiInit })
            setAlreadyInit(true);//suppos to handle with back history to prevant init again before i ride the navigate to dashbord

         } else {
            UmooveApi.API_loadUmooveLibrary()
               .then((stream) => {
                  if (window.buildType == "iPhone") {
                     const cameraWindowEL = document.querySelector('.cameraWindow');
                     // Adjust styles for Safari
                     cameraWindowEL.style.zIndex = '200';
                     cameraWindowEL.style.opacity = '1';
                  } else {
                     videoRef.current.srcObject = stream;
                  }
                  setStreamObj(stream);
                  setAlreadyInit(true);
                  setLoader("");//mean that the camera now is on- client can press next now
               })
               .catch((e) => {
                  console.log(e);
                  // alert("error")
               });
         }
      }
      return () => {
         if (waitForCameraPluginInterval) {

            clearInterval(waitForCameraPluginInterval);
         }
         if (window.buildType == "iPhone") {
            const cameraWindowEL = document.querySelector('.cameraWindow');
            cameraWindowEL.style.zIndex = '-10';
            cameraWindowEL.style.opacity = '0';
         }
      }
   }, []);

   const nextPage = () => {
      try {
         window.debuggCollector("nextPageFunc", { loaderStae: loader })
         let sucsses;
         if (!window.cordovaOn) {

            if (!videoRef.current.srcObject && window.buildType !== "iPhone") {
               console.log("🚀 ~ file: index.jsx:30 ~ nextPage ~ srcObject:", videoRef.current.srcObject)

               return
            }
            //TODO: yos  להשוות לפונקציות האחרות שמפעילות את יומוב נראה שבכולן הכוונה היא אחת -משך זמן שהיה עד לייצוב- אך הישום שונה
            UmooveApi.API_startUmoove();
         }
         let count = 0
         window.debuggCollector("StartInterval", "searchForEye")
         const interval = setInterval(() => {
            try {

               setLoader("searchEye")
               count++
               // setCount(prev => prev++);
               console.log({ count });

               if (count > 10) {
                  window.debuggCollector("clearInterval", "notFindEye")
                  clearInterval(interval);
                  setLoader("")
                  throw { message: "user eye not find in 10 second" }
               }

               sucsses = UmooveApi.API_getUmooveTracking();
               console.log({ sucsses });

               if (sucsses === true) {
                  window.debuggCollector("insideInterval", `findEye in ${count} seconds`)
                  setLoader("loadImg")
                  clearInterval(interval);
                  const image = new Image();
                  image.src = `https://firebasestorage.googleapis.com/v0/b/readmateapp-696eb.appspot.com/o/tests_images%2F${examData.title}?alt=media`;

                  image.onload = () => {
                     if (window.cordovaOn) {
                        window.debuggCollector("insideInterval", `calling to hide video`)
                        UmooveApi.API_startUmoove(false);//mean start umoove without preview
                        window.debuggCollector("insideInterval", `hide video success`)
                     }
                     navigate("/assessments/comprehension", { state: { data: " l.state.data", image: image.src } });
                  };
               }
            } catch (err) {
               window.debuggCollector("errorInsideInterval", err)
               userRequests.userDebugg(window.debuggarray, userDetails);
            }
         }, 1000);

      } catch (err) {
         window.debuggCollector("errorOutsideInterval", err)
         userRequests.userDebugg(window.debuggarray, userDetails);
      }
   };

   return (
      <div className={styles.container}>

         <div>
            {!window.cordovaOn && <div style={window.buildType == "iPhone" ? { opacity: "0" } : { opacity: "1" }} className={`${styles.camera} `}>
               {window.buildType == "iPhone" ?
                  <video ref={videoRef} playsinline className="focus-video" />
                  :
                  <video ref={videoRef} autoPlay className="focus-video" />


               }
            </div>}
            <StartFooter
               subtitle="CLEAN FRONT FACING CAMERA LENS"
               startFunction={() => nextPage()}
               title="Start now"
               explanation='Make sure your eyes are clearly visible. Then press ‘Start Now’ to begin reading the passage.'
               img={group}
               loader={loader}
            />

         </div>
      </div>
   );
}

export default CameraFace;